import { createFileRoute } from "@tanstack/react-router"

import { DealsListView } from "../../../components/deal-packets/deals-list-view"

export const Route = createFileRoute("/$dealership/deal-packets/")({
  component: DealsIndexPage,
})

function DealsIndexPage() {
  const { dealership, stores } = Route.useRouteContext()

  if (!dealership) return null

  return <DealsListView dealershipSlug={dealership.slug} stores={stores} />
}
